import { useTranslation } from 'react-i18next';
import { useHomeTranslationsQuery } from '../../../services/HomePageServices';
import { useFeatureToggles } from '../../../contexts/FeatureTogglesContext';
import { useState } from 'react';
import { Container } from 'react-bootstrap';
import parse from 'html-react-parser';
import LazyVideo from '../../common/LazyVideo';
import playIcon from '../../../assets/images/icon/icon-play.svg';
import iconCalender from '../../../assets/images/icon/icon-calendar.svg';
import iconLocation from '../../../assets/images/icon/icon-location.svg';
import { Nav } from 'react-bootstrap';
import { sanitizeCmsHtml } from '../../../helpers/sanitizeCmsHtml';

function EventDetailsSection() {
  const { application } = useFeatureToggles();
  const { t: tEventDetails } = useTranslation('event_details');

  const { data: homeTranslations, isLoading } = useHomeTranslationsQuery();

  const mediaLink = tEventDetails('media_link');
  const mediaThumbnail = tEventDetails('media_thumbnail');
  const dateRange = tEventDetails('event_details_date');
  const location = tEventDetails('event_details_location');
  const hasMediaLink = !!mediaLink && mediaLink !== 'media_link';
  const hasMediaThumbnail = !!mediaThumbnail && mediaThumbnail !== 'media_thumbnail';
  const hasEventDetailsHeader = !!tEventDetails('event_details_header') && tEventDetails('event_details_header') !== 'event_details_header';
  const hasDateRange = !!dateRange && dateRange !== 'event_details_date';
  const hasLocation = !!location && location !== 'event_details_location';
  const showVideoPlayer = hasMediaLink && hasMediaThumbnail;
  const fallbackImageSrc = hasMediaLink ? mediaLink : (hasMediaThumbnail ? mediaThumbnail : '');
  const hasApplyButtonText = !!tEventDetails('event_details_button_text') && tEventDetails('event_details_button_text') !== 'event_details_button_text';
  const hasApplyButtonLink = !!tEventDetails('event_details_button_link') && tEventDetails('event_details_button_link') !== 'event_details_button_link';
  const showApplyButton = application && hasApplyButtonText && hasApplyButtonLink;

  const [showVideoControls, setShowVideoControls] = useState(false);

  const playVideo = () => {
    const videoEl = document.getElementById('hackathon-video');
    if (videoEl instanceof HTMLVideoElement) {
      setShowVideoControls(true);
      videoEl.play();
    }
  };

  if (!homeTranslations || isLoading) return null;

  return (
    <section id='event-details' className='hackathon-recap'>
      <Container className='hackathon-recap__container'>
        <div className="recap-container">
          <div className="recap_container">
            {hasEventDetailsHeader ? (
              <div className="name">{tEventDetails('event_details_header')}</div>
            ) : null}
            <div className="title">{tEventDetails('event_details_title')}</div>
            <div className="description">{parse(sanitizeCmsHtml(tEventDetails('event_details_description')))}</div>
            {(hasDateRange || hasLocation) ? (
              <div className="detail-group">
                {hasDateRange ? (
                  <div>
                    <img src={iconCalender} alt='Calendar Icon' loading="lazy" decoding="async" /> {dateRange}
                  </div>
                ) : null}
                {hasLocation ? (
                  <div>
                    <img src={iconLocation} alt='Location Icon' loading="lazy" decoding="async" /> {location}
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className='button-group'>
              {showApplyButton ? (
                <>
                  <div className='button'>
                    <Nav.Link
                      className="__apply-button"
                      href={tEventDetails('event_details_button_link')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {tEventDetails('event_details_button_text')}
                    </Nav.Link>
                  </div>
                </>
              ) : null}
              <div className='button-description'>{parse(sanitizeCmsHtml(tEventDetails('event_details_button_description')))}</div>
            </div>
          </div>
          {(hasMediaLink || hasMediaThumbnail) ? (
            <div className='video_container'>
              {showVideoPlayer ? (
                <>
                  <LazyVideo
                    className={showVideoControls ? 'fit-contain' : 'fit-cover'}
                    src={mediaLink}
                    preload="none"
                    width="100%"
                    poster={mediaThumbnail}
                    controls={showVideoControls}
                    videoId='hackathon-video'
                  />
                  <img
                    src={playIcon}
                    alt='Play Icon'
                    onClick={playVideo}
                    hidden={showVideoControls}
                    className='overlay_icon'
                    loading="lazy"
                    decoding="async"
                  />
                </>
              ) : (
                <img
                  src={fallbackImageSrc}
                  alt='Event Details Visual'
                  className='fit-cover'
                  loading="lazy"
                  decoding="async"
                />
              )}
            </div>
          ) : null}
        </div>
      </Container>
    </section>
  );
}

export default EventDetailsSection;
